import { UseCase } from "@domain/base/use-case";
import { UserPlansSummaryFilters } from "@domain/models/user.model";
import { UserRepository } from "@domain/repositories/user.repository";
import { Observable } from "rxjs";

export class GetUsersExcelReportUseCase implements UseCase<UserPlansSummaryFilters, File> {
  constructor(private readonly userRepository: UserRepository) {}

  execute(filters: UserPlansSummaryFilters): Observable<File> {
    return this.userRepository.getUserExcelReport(filters);
  }
}
